import type { PageArchiveThumbFragment, PageGlossaryArchiveThumbFragment } from '#graphql-operations'

export type ArchivePageEntry = PageArchiveThumbFragment | PageGlossaryArchiveThumbFragment

export default defineNuxtPlugin({
  name: 'archive-pages',
  enforce: 'pre',
  dependsOn: [
    'nuxt-graphql-middleware-provide-state',
    'i18n:plugin:route-locale-detect',
  ],
  async setup() {
    const { $i18n, isHydrating } = useNuxtApp()
    const site = computed(() => $i18n.locale.value)
    const archivePages = useState<ArchivePageEntry[]>('archive-pages', () => [])

    if (import.meta.server) {
      const { data } = await useGraphqlQuery('Entries', {
        type: ['pageGlossaryArchive', 'pageArchive'],
        site: [site.value],
      })

      archivePages.value = (data.entries ?? []) as ArchivePageEntry[]
    }
    else if (import.meta.client && !isHydrating) {
      watch(site, async (newSite) => {
        const { data } = await useGraphqlQuery('Entries', {
          type: ['pageGlossaryArchive', 'pageArchive'],
          site: [newSite],
        })

        archivePages.value = (data.entries ?? []) as ArchivePageEntry[]
      })
    }
  },
})
